export const MUSIC_TRACKS = [
  {
    id: 'pebble_stream',
    name: 'Pebble in the Stream',
    sources: [
      '/audio/Pebble_in_the_Stream.ogg',
      '/audio/Pebble_in_the_Stream.mp3',
    ],
  },
  {
    id: 'water_rests',
    name: 'Where the Water Rests',
    sources: [
      '/audio/Where_the_Water_Rests.ogg',
      '/audio/Where_the_Water_Rests.mp3',
    ],
  },
] as const;

export type MusicTrackId = (typeof MUSIC_TRACKS)[number]['id'];

export const DEFAULT_MUSIC_TRACK_ID: MusicTrackId = MUSIC_TRACKS[0].id;

export function getMusicTrack(id: MusicTrackId): (typeof MUSIC_TRACKS)[number] {
  return MUSIC_TRACKS.find((track) => track.id === id) ?? MUSIC_TRACKS[0];
}
